/*
 * @Author: Dong
 * @Date: 2022-04-20 11:14:22
 * @LastEditors: zhang lin
 * @LastEditTime: 2022-06-01 18:26:51
 */
import { Dispatch } from 'redux';
import { getLogList } from 'root/services/syncBack';
import { GET_LOG_RECORD, SET_LODING } from '../constant';
import { logSearchParams } from './types';

const initParams = {
  current: 1,
  pageSize: 20,
};

// 获取日志记录
export const getLogRecord = (params: logSearchParams = initParams) => {
  return (dispatch: Dispatch) => {
    dispatch({
      type: SET_LODING,
      payload: true,
    });
    getLogList(params)
      .then((result) => {
        return dispatch({
          type: GET_LOG_RECORD,
          payload: result.data,
        });
      })
      .finally(() => {
        dispatch({
          type: SET_LODING,
          payload: false,
        });
      });
  };
};

// 设置表格loding
export const setLoging = (params: boolean) => {
  return (dispatch: Dispatch) => {
    return dispatch({
      type: SET_LODING,
      payload: params,
    });
  };
};
